import { render, staticRenderFns } from "./GroupLayout.vue?vue&type=template&id=c2fc3424"
import script from "./GroupLayout.vue?vue&type=script&lang=js"
export * from "./GroupLayout.vue?vue&type=script&lang=js"
import style0 from "./GroupLayout.vue?vue&type=style&index=0&id=c2fc3424&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports